import {action, computed, observable, toJS} from 'mobx';
import {BaseStore} from '../base';
import {Site} from '../../models/site';
import {callSmsSend} from '../../helpers/api/sms';
import {message} from 'antd';

export class SendSmsStore extends BaseStore {
  @observable form = {
    phones: [],
    message: '',
    site: Site.RusPropusk
  };

  @observable validations = {
    phones: '',
    message: '',
  };

  @observable isSending = false;
  @observable isPhonesReadonly = false;

  @action initialize(phones, site) {
    this.form = {phones, site, message: ''};
    // если у нас предустановленные телефоны, то не разрешаем их менять
    this.isPhonesReadonly = phones.length > 0;
  }

  @action patchForm(formPartial) {
    this.form = { ...this.form, ...formPartial };
    this.validate(Object.keys(formPartial))
  }


  @action async send() {
    this.validate();

    if (!this._isFormValid()) {
      message.error('Заполните все поля');
      return ;
    }

    this.isSending = true;
    await callSmsSend(this.form);
    this.isSending = false;

    message.success('Сообщение успешно отправлено');
  }

  _isFormValid() {
    console.log(Object.values(toJS(this.form)));
    return Object.values(toJS(this.validations)).every(i => i === 'success');
  }

  @action validate(keys) {
    if (!keys) {
      keys = Object.keys(toJS(this.form));
    }

    for (const key of keys) {
      if (key === 'phones') {
        this.validatePhones();
      } else if (key === 'message') {
        this.validateMessage();
      }
    }
  }

  @action validatePhones() {
    this.validations.phones = this.form.phones.filter(i => i.trim().length).length > 0 ? 'success' : 'error';
  }

  @action validateMessage() {
    this.validations.message = this.form.message && this.form.message.trim().length > 0 ? 'success' : 'error';
  }

  @computed get formMessageInfo() {
    const len = this.form.message.length

    // если смс одно - то 70
    // если больше одного то по 67 каждое
    let countSms, maxSymbols;
    if (len <= 70) {
      countSms = 1;
      maxSymbols = 70;
    } else {
      countSms = Math.ceil(len / 67);
      maxSymbols = Math.ceil(countSms * 67);
    }

    return {
      current: len,
      countSms: countSms,
      maxSymbols: maxSymbols
    };
  }

}



// WEBPACK FOOTER //
// ./src/stores/sms/send-sms-store.js